import React, { useEffect, useRef } from "react";
import Pin from "../../../assets/pin.png";
import Dart from "../../../assets/dart.png";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const About = () => {
  const titleRef = useRef(null);
  const textRef = useRef(null);
  const textRef2 = useRef(null);

  const onPlayerReady = (event) => {
    // access to player in all event handlers via event.target
    event.target.pauseVideo();
  };

  const opts = {
    height: "390",
    width: "100%",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
    },
  };

  useEffect(() => {
    gsap.fromTo(
      titleRef.current,
      { y: 0 },
      {
        y: -50,
        duration: 1,
        scrollTrigger: {
          trigger: titleRef.current,
        },
      },
    );
  });
  // write me an about me section for my portfolio, I'm a frontend developer and UI/UX designer who loves telling stories using digital tools
  return (
    <div
      id="about"
      className="layout my-24 flex flex-col gap-2 text-white lg:mt-48 lg:gap-3 2xl:mt-64">
      <h1
        ref={titleRef}
        className="relative font-semibold leading-tight text-5xl xl:text-6xl 2xl:text-7xl">
        About me
      </h1>
      <div className="space-y-4 md:space-y-8">
        <p
          ref={textRef}
          className="w-[95%] sm:w-[85%] font-light leading-loose sm:text-xl text-N80"
        >
          I'm a frontend engineer with over 4 years of experience building
          AI-powered interfaces, complex dashboards, and high-performance web
          apps. I built the chat-based legal AI interface for Lizzy AI, shipped
          a national labor market platform used by thousands across Ethiopia,
          and led UI/UX and frontend for Mookoob — a services marketplace
          based in Belgium.
        </p>
        <p
          ref={textRef2}
          className="w-[95%] sm:w-[85%] font-light leading-loose sm:text-xl text-N80"
        >
          I work across the full frontend stack — React, Next.js, TypeScript,
          GraphQL — and integrate AI tools like Claude Code into my workflow to
          ship faster without cutting corners on quality.
        </p>
      </div>
    </div>
  );
};

export default About;
